<template>
  <div class="px-3">
    <v-card class="top-row py-2 px-3 mb-4" elevation="2">
      <div style="250px">
        <v-text-field
          class="search-field mr-2"
          label="Sök efter faktaruta"
          prepend-inner-icon="mdi-magnify"
          clearable
          outlined
          dense
          hide-details="true"
          @input="onSearch"
        ></v-text-field>
      </div>
      <v-btn size="large" color="primary" :to="{ name: 'NewFact' }"> Skapa ny faktaruta </v-btn>
    </v-card>
    <v-expansion-panels focusable>
      <v-expansion-panel v-for="fact in facts" :key="fact.id">
        <v-expansion-panel-header class="fact-title">
          {{ fact.title_sve }}

          <template #actions>
            <v-icon color="green"> mdi-chevron-down </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pt-3">
          <v-card :elevation="0">
            {{ fact.text_sve }}
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                color="green"
                @click="$router.push({ name: 'editFact', params: { id: fact.id } })"
              >
                Ändra
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <router-view
      v-if="isInitialized"
      :loading="loading"
      @fact:update="onUpdate"
      @fact:save="onSave"
      @fact:delete="onDelete"
    ></router-view>
    <Message ref="message" />
    <Confirm ref="confirm" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Confirm from '@/components/shared/Confirm'
import Message from '@/components/shared/Message'
export default {
  name: 'FactsHome',
  components: {
    Confirm,
    Message,
  },
  data() {
    return {
      isInitialized: false,
      loading: false,
      search: '',
    }
  },
  computed: {
    ...mapGetters('arterFacts', { allArterFacts: 'getArray' }),
    facts() {
      const factList = [...this.allArterFacts].sort((a, b) => a.title_sve.localeCompare(b.title_sve))
      if (!this.search) return factList
      return factList.filter((fact) =>
        fact.title_sve.toLowerCase().includes(this.search.toLowerCase())
      )
    },
  },
  methods: {
    ...mapMutations('arterFacts', { addFilter: 'ADD_FILTER', setOrder: 'SET_SORT' }),
    ...mapActions('arterFacts', {
      getArterFacts: 'readCollection',
      updateFact: 'update',
      deleteFact: 'delete',
      createFact: 'create'
    }),
    async fetch() {
      this.loading = true
      await this.getArterFacts()
      this.loading = false
    },
    onSearch(val) {
      this.search = val
    },
    async onUpdate(payload) {
      await this.updateFact(payload)
      this.$refs.message.open('Fakta sparad')
      this.fetch()
    },
    async onSave(payload) {
      await this.createFact(payload)
      this.$refs.message.open('Fakta sparad')
      this.fetch()
    },
    async onDelete(payload){
      const shouldDelete = await this.$refs.confirm.open({
        title: 'Radera fakta',
        message: 'Är du säker på att du vill radera faktan?',
        saveButtonText: 'Ja',
        cancelButtonText: 'Avbryt',
      })
      if(!shouldDelete) return
      await this.deleteFact(payload)
      this.$refs.message.open('Fakta raderad')
      this.fetch()
    }
  },
  async created() {
    this.addFilter({ key: 'pageSize', value: 9999 })
    this.setOrder({ key: 'name_sve', value: 'ASC' })
    await this.fetch()
    this.isInitialized = true
  },
}
</script>

<style lang="less" scoped>
.fact-title {
  font-weight: 600;
}
.top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
